<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="700px" persistent>
    <v-card>
      <v-card-text>
        <v-flex xs12 sm6 md12>
          <v-text-field label="Login" v-model="itemData.username"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field label="Name" v-model="itemData.name"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field label="Phone" v-model="itemData.phone"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field label="Age" v-model="itemData.age" type="number"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-select :items="sex" label="Sex" v-model="itemData.sex"></v-select>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-textarea outline label="Description" v-model="itemData.description"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field label="Email" v-model="itemData.email"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-select
            :items="rolesList"
            v-model="selectedRoles"
            multiple
            label="Roles"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field label="password" type="password" v-model="itemData.password"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-checkbox v-model="itemData.is_vendor" label="Is bookable"></v-checkbox>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-img
            v-if="avatar"
            size="50"
            aspect-ratio="1"
            :src="avatar"
          ></v-img>
          <v-progress-linear
            v-if="uploadPercentage !== 0 && uploadPercentage !== 100"
            :value="uploadPercentage"
            color="light-blue"
          ></v-progress-linear>
        </v-flex>

        <v-btn
          color="primary"
          class="mt-3 ml-0"
          :disabled="disabled.uploadPhotoForEmbalmersBtn"
          :loading="disabled.uploadPhotoForEmbalmersBtn"
          :prepend-icon="uploadStatus"
          @click="$refs.inputUpload.click()"
          type="file">Upload Optional Photo
        </v-btn>
        <input
          v-show="false"
          accept=".jpg,.png"
          ref="inputUpload"
          type="file"
          @change="onChange"
        >
        <v-snackbar
          v-model="snackbar"
          bottom
          color="success"
          multi-line
          :timeout="2000"
        ></v-snackbar>

        <v-flex xs12 sm6 md12 class="text-md-left" v-if="courses.length > 0">
          <v-data-table
            :items="courses"
            :headers="coursesTableHeaders"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.course_id }}</td>
              <td>{{ props.item.course_completion_percent }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemDataDecorator">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import rolesAPI from '@/api/resources/roles'
  import usersAPI from '@/api/user'
  import inventoriesAPI from '@/api/resources/inventories'
  import servicesAPI from '@/api/resources/services'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ItemCheckList from '@/components/ItemCheckList'
  import UserServices from '@/components/UserServices'

  export default {
    components: {
      ItemCheckList,
      UserServices
    },
    data () {
      return {
        coursesTableHeaders: [
          { text: 'Course ID', value: 'id' },
          { text: 'Percent', value: 'percent' }
        ],

        photoForUser: null,
        userPhotoIsUploaded: false,
        user_photo_url: false,
        uploadPercentage: 0,
        snackbar: false,
        disabled: {
          uploadPhotoForEmbalmersBtn: false
        },
        vendorIsSelected: false,
        resource: 'users',
        rolesList: [],
        selectedRoles: [],
        servicesVendorsList: [],
        serviceDescription: null,
        servicePrice: null,
        servicesList: [],
        sex: ['Male', 'Female'],
        selectedServices: [],
        inventoriesList: [],
        selectedInventories: [],
        courses: [],
        inventoriesVendorsList: []
      }
    },
    computed: {
      uploadStatus () {
        return this.userPhotoIsUploaded ? 'done' : ''
      },
      avatar () {
        return this.user_photo_url || this.itemData.avatar || this.$dfsConfig.default_avatar_url
      },
      coursesCompletitionPercent (coursesData) {
        let coursesObject = JSON.parse(coursesData)
        let result = 0

        if (coursesObject) {
          let courses = Object.keys(coursesObject)

          let coursesCommonPercents = courses.reduce((accumulator, course) => {
            let commonEarnedForCourse = coursesObject[course].reduce((accumulateEarnedForCourse, courseBlock) => {
              accumulateEarnedForCourse += courseBlock.earned_all

              return accumulateEarnedForCourse
            }, 0)

            let commonPossibleForCourse = coursesObject[course].reduce((accumulatePossibleForCourse, courseBlock) => {
              accumulatePossibleForCourse += courseBlock.possible_all

              return accumulatePossibleForCourse
            }, 0)

            accumulator += parseInt(commonEarnedForCourse / commonPossibleForCourse * 100)

            return accumulator
          }, 0)

          result = parseInt(coursesCommonPercents / courses.length)
        }

        return result
        // return this.itemData.courses_completion_percent ? this.itemData.courses_completion_percent : 0
      }
    },
    watch: {
      itemData (newVal) {
        this.selectedRoles = []
        this.inventoriesList = []
        this.servicesList = []
        this.selectedInventories = []
        this.selectedServices = []

        this.user_photo_url = newVal.avatar || null

        if (this.itemId > 0) {
          this.courses = this.normalizeCourses(this.itemData.courses_completion_percent)

          if (this._.has(this.itemData, 'service.description')) {
            this.serviceDescription = this._.get(this.itemData, 'service.description')
            this.servicePrice = this._.get(this.itemData, 'service.price')
          }

          inventoriesAPI.loadNotAssociatedVendorsInventories().then(result => {
            this.inventoriesVendorsList = result
          }, () => {
          })

          servicesAPI.loadNotAssociatedVendorsServices().then(result => {
            this.servicesVendorsList = result
          }, () => {
          })

          usersAPI.getLinkedRoles(this.itemId).then(result => {
            result.forEach((item, i) => {
              this.rolesList.forEach((role, index) => {
                if (role.id === item.id) {
                  this.selectedRoles.push(role.id)
                }
              })
            })
          }, () => {
          })

          usersAPI.getLinkedInventories(this.itemId).then(result => {
            result.forEach(item => {
              item.text = item.name
              item.value = item.id
            })

            this.inventoriesList = result.concat(this.inventoriesVendorsList)

            this.selectedInventories = result.map(item => item.id)
          }, () => {
            this.inventoriesList = this.inventoriesVendorsList
          })

          usersAPI.getLinkedServices(this.itemId).then(result => {
            result.forEach(item => {
              item.text = item.name
              item.value = item.id
            })

            this.servicesList = result.concat(this.servicesVendorsList)

            this.selectedServices = result.map(item => item.id)
          }, () => {
            this.servicesList = this.servicesVendorsList
          })
        }
      },
      selectedRoles (newVal) {
        this.itemData.roles = newVal

        this.rolesList.forEach(item => {
          if (item.name === 'vendor') {
            if (this.selectedRoles.includes(item.id)) {
              this.vendorIsSelected = true
            } else {
              this.vendorIsSelected = false
            }
          }
        })
      },
      photoForUser (photo) {
        let form = new FormData()
        form.append('avatar', photo)
        this.$store.getters.axios.post(this.$store.getters.config.api_host + '/api/users/' + this.itemData.id + '/avatar', form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }.bind(this)
        }).then(result => {
          this.user_photo_url = result.data.additional_data
          this.disabled.uploadPhotoForEmbalmersBtn = false
          this.userPhotoIsUploaded = true

          this.snackbar = true
          setTimeout(() => {
            this.userPhotoIsUploaded = false
          }, 5000)
        })
      }
    },
    methods: {
      normalizeCourses (coursesData) {
        let normalizedCourses = []
        let coursesObject = JSON.parse(coursesData)

        if (coursesObject) {
          let courses = Object.keys(coursesObject)

          normalizedCourses = courses.map(course => {
            let commonEarnedForCourse = coursesObject[course].reduce((accumulateEarnedForCourse, courseBlock) => {
              accumulateEarnedForCourse += courseBlock.earned_all

              return accumulateEarnedForCourse
            }, 0)

            let commonPossibleForCourse = coursesObject[course].reduce((accumulatePossibleForCourse, courseBlock) => {
              accumulatePossibleForCourse += courseBlock.possible_all

              return accumulatePossibleForCourse
            }, 0)

            return {
              course_id: course,
              course_completion_percent: parseInt(commonEarnedForCourse / commonPossibleForCourse * 100)
            }
          })
        }

        return normalizedCourses
      },
      onChange (event) {
        this.photoForUser = event.target.files[0]
      },
      editItemDataDecorator () {
        if (this.serviceDescription) {
          if (this._.has(this.itemData, 'service.id')) {
            this.itemData.service.description = this.serviceDescription
          } else {
            this.itemData.service = { description: this.serviceDescription }
          }

          if (this.vendorIsSelected) {
            this.itemData.inventories = this.selectedInventories
            this.itemData.services = this.selectedServices
            this.itemData.service.price = this.servicePrice
          }

          this.itemData.service.is_vendor = this.vendorIsSelected
        }

        this.editItemData()
      }
    },
    mixins: [ dialogMixins, itemTypesMixins ],
    created () {
      rolesAPI.loadRoles().then(result => {
        this.rolesList = result
      })
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditUsersDialog.vue?ea73103c